import React, { useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import Navbar2 from "../Header/Navbar2";
import Breadcrumb from "./Breadcrumb";
import Footer from "../Pages/Home/Footer";

import { IoWalletOutline } from "react-icons/io5";
import { PiTreeStructure } from "react-icons/pi";
import { RiDashboardLine } from "react-icons/ri";

const DashboardLayout = () => {
    const location = useLocation();
    const detailPagePath = "/detail";
    const adminDashboardPath = "/admin";

    // const isActive = (path) => location.pathname === path;
    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(path);
    };

    const subStatus = sessionStorage.getItem("subscription_status");

    // Determine when to show the sidebar and breadcrumb
    const shouldShowSidebar = location.pathname !== "/home" && location.pathname !== detailPagePath && location.pathname !== adminDashboardPath;

    const shouldShowBreadcrumb = location.pathname !== "/home" && location.pathname !== detailPagePath && location.pathname !== adminDashboardPath;

    const navbarShow = location.pathname == "/subscription";
    return (
        <section className={` ${!shouldShowSidebar ? "hide-sidebar nav-shadow" : ""}`}>
            <div className="container-fluid bg-white nav-bar">
                <div className="container d-sm-none d-md-none d-lg-block">
                    <div className="horizontal-divider-black mb-1px"></div>
                </div>
                <div className="container d-sm-none d-md-none d-lg-block">
                    <div className="horizontal-divider-black"></div>
                </div>
                <div className="dashboard-nav">
                    <div className="container">
                        {!navbarShow && shouldShowSidebar && (
                            <aside className="sidebar">
                                <nav className="d-sm-none d-md-flex">
                                    <ul className="nav">
                                        <li className={`nav-item ${isActive("/dashboard") ? "active" : ""}`}>
                                            <Link to="/dashboard" className={` nav-link text-dark ${isActive("/dashboard") ? "highlighed-navitem" : ""}`}>
                                                <RiDashboardLine className="f-20 me-2" />
                                                <span className="f-16">Dashboard</span>
                                            </Link>
                                        </li>
                                        <li className={`nav-item dropdown ${isActive("/downline") || isActive("/genealogy") ? "highlighed-navitem" : ""}`}>
                                            <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <PiTreeStructure className="f-20 me-2" />
                                                <span className="f-16">Network</span>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link
                                                        to="/downline"
                                                        className={`dropdown-item ${
                                                            isActive("/downline") || isActive("/addmember") || isActive("/editmember")
                                                                ? "highlighed-navitem"
                                                                : ""
                                                        }`}
                                                    >
                                                        Downline Member
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/genealogy" className={`dropdown-item ${isActive("/genealogy") ? "highlighed-navitem" : ""}`}>
                                                        Genealogy Tree
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={`nav-item dropdown ${isActive("/ewallet") || isActive("/payout") ? "highlighed-navitem" : ""}`}>
                                            <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <IoWalletOutline className="f-20 me-2" />
                                                <span className="f-16">Finance</span>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link to="/ewallet" className={`dropdown-item ${isActive("/ewallet") ? "highlighed-navitem" : ""}`}>
                                                        E-wallet
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/payout" className={`dropdown-item ${isActive("/payout") ? "highlighed-navitem" : ""} `}>
                                                        Payout
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={`nav-item ${isActive("/settings") ? "highlighed-navitem" : ""} `}>
                                            <Link to="/settings" className="nav-link text-dark">
                                                <i className="bi bi-gear f-18 me-2"></i>
                                                <span className="f-16">Settings</span>
                                            </Link>
                                        </li>
                                         <li className={`nav-item ${isActive("/invite-topline") ? "highlighed-navitem" : ""} `}>
                                            <Link to="/invite-topline" className="nav-link text-dark">
                                                <i className="bi bi-people f-18 me-2"></i>
                                                <span className="f-16">Invite Members For TopLine</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                                <nav className="d-sm-flex d-md-none d-lg-none">
                                    <ul className="nav">
                                        <li className={`nav-item ${isActive("/dashboard") ? "highlighed-navitem" : ""}`}>
                                            <Link to="/dashboard" className="nav-link text-dark">
                                                <RiDashboardLine className="f-20 me-2" />
                                                <span className="f-16"></span>
                                            </Link>
                                        </li>
                                        <li className={`nav-item dropdown ${isActive("/downline") || isActive("genealogy") ? "highlighed-navitem" : ""}`}>
                                            <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <PiTreeStructure className="f-20 me-2" />
                                                <span className="f-16"></span>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link to="/downline" className={`dropdown-item ${isActive("/downline") ? "highlighed-navitem" : ""}`}>
                                                        Downline Member
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/genealogy" className={`dropdown-item ${isActive("/genealogy") ? "highlighed-navitem" : ""}`}>
                                                        Genealogy Tree
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <button className="nav-link text-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <IoWalletOutline className="f-20 me-2" />
                                                <span className="f-16"></span>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link to="/ewallet" className={`dropdown-item ${isActive("/ewallet") ? "highlighed-navitem" : ""}`}>
                                                        E-wallet
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/payout" className={`dropdown-item ${isActive("/payout") ? "highlighed-navitem" : ""}`}>
                                                        Payout
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item ">
                                            <Link to="/settings" className="nav-link text-dark">
                                                <i class="bi bi-gear f-18 me-2 fw-bold"></i>
                                            </Link>
                                        </li>
                                         <li className={`nav-item ${isActive("/invite-topline") ? "highlighed-navitem" : ""} `}>
                                            <Link to="/invite-topline" className="nav-link text-dark">
                                                <i className="bi bi-people f-18 me-2"></i>
                                                <span className="f-16">Invite Members For TopLine</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </aside>
                        )}
                    </div>
                </div>
            </div>

            <div className="light-bg">
                <div className="container">
                    <main className="content-container">
                        {!navbarShow && shouldShowBreadcrumb && <Breadcrumb />}
                        <Outlet />
                    </main>
                </div>
            </div>
            <style jsx>
                {`
                    .highlighed-navitem {
                        font-weight: 550;
                    }
                `}
            </style>
        </section>
    );
};

export default DashboardLayout;
